var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive, Input, forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
var MinValueValidator = /** @class */ (function () {
    function MinValueValidator() {
    }
    MinValueValidator_1 = MinValueValidator;
    MinValueValidator.prototype.validate = function (control) {
        var givenvalue = control.value;
        var validationResult = null;
        var minValue = this.minValue;
        if (minValue && givenvalue < minValue) {
            validationResult = validationResult || {};
            validationResult.minValue = true;
        }
        return validationResult;
    };
    var MinValueValidator_1;
    __decorate([
        Input('minValue')
    ], MinValueValidator.prototype, "minValue", void 0);
    MinValueValidator = MinValueValidator_1 = __decorate([
        Directive({
            selector: '[minValue]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return MinValueValidator_1; }), multi: true }
            ]
        })
    ], MinValueValidator);
    return MinValueValidator;
}());
export { MinValueValidator };
